import React, { useState, useEffect } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Tooltip, Box, Grid, Typography, Card, Button, IconButton, Chip, Skeleton, Avatar, Link as MuiLink } from '@mui/material';
import { Facebook, Instagram, X, LinkedIn, YouTube } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Header1 from '../Header/Header1';
import Footer from '../Footer/Footer';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ReportIcon from '@mui/icons-material/Report';
import ShareButton from "../Share/ShareButton";
import Footer2 from '../Footer/Footer2';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import PostRecommendations from '../Recommendations/PostRecommendations';
import avatar from './default-avatar.png'
import ShareIcon from '@mui/icons-material/Share';
import FlagIcon from '@mui/icons-material/Flag';
import { styled } from '@mui/system';
import UserFeedbacks from '../User/UserFeedbacks';
import GoogleMeetLogo from './GoogleMeetImage.png';
import ZoomMeetLogo from './ZoomMeetImage.png';
import TeamsMeetLogo from './TeamsMeetImage.png';
import YouTubeEmbed from '../UserProfile/YouTubeEmbed';
import ViewsLikesAnalytics from './ViewsLikesAnalytics';
import { CheckCircleOutline } from '@mui/icons-material';
import { ErrorOutline } from '@mui/icons-material';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';



const API_URL = process.env.REACT_APP_API_URL;


const PostTabDetails = ({ onLogout }) => {


    useEffect(() => {
        window.scrollTo(0, 0);  // Scroll to top when this page is loaded
    }, []);


    const { id, userId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [course, setCourse] = useState(null);
    const [action, setAction] = useState(null);
    const [bookingCreated, setBookingCreated] = useState(false)
    const paymentStatus = location.state?.paymentStatus || 'unknown';  // Default to 'unknown' if not provided
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);



    const getLogo = (platform) => {
        switch (platform) {
            case 'googleMeet':
                return GoogleMeetLogo;
            case 'zoom':
                return ZoomMeetLogo;
            case 'microsoftTeams':
                return TeamsMeetLogo;
            default:
                return null; // Optionally, you can return a default image or a placeholder here
        }
    };


    const getPlatformName = (platform) => {
        switch (platform) {
            case 'googleMeet':
                return 'Google Meet';
            case 'zoom':
                return 'Zoom';
            case 'microsoftTeams':
                return 'Microsoft Teams';
            default:
                return null;
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${API_URL}/get_posted_data/?post_id=${id}`);
                setCourse(response.data[0]);
                await createRecentActivity(userId, id);
                UpdatePostViews();
                updateRecentViewedPost(userId, id);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, [id, userId]);  // Depend on 'id' and 'userId' to ensure the data and view count is fetched only once


    useEffect(() => {
        const getUserPostInteraction = async () => {
            try {
                const response = await axios.get(
                    `${API_URL}/get_user_post_interaction/`,
                    {
                        params: {
                            user_id: userId,
                            post_id: id,
                        },
                    }
                );
                setAction(response.data.action); // Set the action (like, dislike, or null)
            } catch (error) {
                setAction(null);
                console.error("Error fetching user post interaction:", error);
            }
        };

        getUserPostInteraction();
    }, [userId, id]);

    const handleLogout = () => {
        onLogout();
        navigate('/login');
    };


    const createUserPostBookings = async () => {
        try {
            const response = await fetch(`${API_URL}/create_user_post_booking/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    post_id: id,
                    user_id: userId,
                }),
            });

            const data = await response.json();
            if (response.ok) {
                setBookingCreated(true);
            }
        } catch (error) {
            console.error('Error creating booking:', error);
        }
    };

    const updateRecentViewedPost = async (userId, postId) => {
        try {
            const response = await axios.patch(`${API_URL}/update-recent-viewed-post/`, {
                user_id: userId,
                post_id: postId,
            });

        } catch (error) {
            console.error('Error updating recent viewed post:', error.response ? error.response.data : error.message);
        }
    };

    const ProfileAvatar = styled(Avatar)(({ theme }) => ({
        width: theme.spacing(40),
        height: theme.spacing(40),
        borderRadius: '50%',
        border: `4px solid ${theme.palette.primary.main}`,
        marginRight: theme.spacing(4),
        borderColor: '#5555',
        "&:hover": {
            transform: "translateY(-3px)",
            borderColor: '#1E90FF',
            boxShadow: "0 10px 20px rgba(0, 0, 0, 0.15)",
        },
    }));



    const UpdatePostViews = async () => {
        try {
            const response = await axios.post(`${API_URL}/update_post_views/?post_id=${id}`);
        } catch (error) {
            console.error('Error updating post views:', error);
        }
    };

    const createRecentActivity = async (userId, postId) => {
        try {
            const response = await fetch(`${API_URL}/create_recent_activity_post/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    user_id: userId,
                    post_id: postId,
                }),
            });

            const data = await response.json();
            if (response.ok) {
            } else {
                console.error('Error logging recent activity:', data);
            }
        } catch (error) {
            console.error('Error calling create_recent_activity API:', error);
        }
    };

    if (!course) {
        return <Typography variant="h6" sx={{ textAlign: "center", padding: "2rem" }}>Loading...</Typography>;
    }

    const formatStartTime = (time) => {
        const [hours, minutes] = time.split(':');
        const dateObj = new Date();
        dateObj.setHours(hours);
        dateObj.setMinutes(minutes);

        const formatter = new Intl.DateTimeFormat('en-US', {
            hour: '2-digit', minute: '2-digit', hour12: true
        });

        return formatter.format(dateObj); // returns time in AM/PM format
    }

    const formatDuration = (durationInMinutes) => {
        const hours = Math.floor(durationInMinutes / 60);
        const minutes = durationInMinutes % 60;

        // If duration is less than an hour, only show minutes
        if (hours > 0) {
            return `${hours} hour${hours > 1 ? 's' : ''} ${minutes} minute${minutes !== 1 ? 's' : ''}`;
        }

        return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
    };

    const formatExperience = (experience) => {
        // If experience exists and is in the format HH:MM
        if (experience) {
            let minutes = experience.split(':')[0];  // Extract the minute value before ":"
            return `${minutes} min`;
        } else {
            return "New user";  // If no experience, return "New user"
        }
    }


    const {
        topic_name, section_name, subsection_name, description, language, date, start_time,
        duration, seats_left, total_seats, name, surname, profile_picture,
        about, rating, experience, id: cardId, price,
        facebook, instagram, x, linkedin, youtube, likes, dislikes, specialized_fields, roles, user_id, meeting_platform,
    } = course;

    const durationFormatted = formatDuration(duration)
    const teacherRating = rating || "Not rated yet";
    const formattedStartTime = formatStartTime(start_time);
    const formatedExperience = formatExperience(experience)

    const UpdatePostLikes = async (post_id) => {
        try {
            const response = await axios.post(`${API_URL}/update_post_likes/?post_id=${post_id}&user_id=${userId}`);
            setCourse(prevCourse => ({
                ...prevCourse,
                likes: response.data.likes,
                dislikes: response.data.dislikes
            }));
        } catch (error) {
            console.error('Error updating post views:', error);
        }
    };

    const handleLikeClick = (post_id) => {
        if (action === 'like') {
            return; // Prevent double-clicking the same action
        }

        UpdatePostLikes(post_id)
        setAction('like');
    };

    const UpdatePostDisLikes = async (post_id) => {
        try {
            const response = await axios.post(`${API_URL}/update_post_dislikes/?post_id=${post_id}&user_id=${userId}`);
            setCourse(prevCourse => ({
                ...prevCourse,
                likes: response.data.likes,
                dislikes: response.data.dislikes
            }));
        } catch (error) {
            console.error('Error updating post views:', error);
        }
    };


    const handleDisLikeClick = (post_id) => {
        if (action === 'dislike') {
            return; // Prevent double-clicking the same action
        }

        UpdatePostDisLikes(post_id)
        setAction('dislike');
    };


    const handleShareClick = () => {
    };

    const ReportPosts = async (post_id) => {
        try {
            const response = await axios.post(`${API_URL}/report_posts/?post_id=${post_id}&user_id=${userId}`);

        } catch (error) {
            console.error('Error updating post views:', error);
        }
    };

    const handleReportClick = (post_id) => {
        const isConfirmed = window.confirm("Are you sure you want to report this post?");

        if (isConfirmed) {
            // Proceed with the report action if confirmed
            ReportPosts(post_id);
        } else {
            // Optionally handle the cancel action here if needed (e.g., logging or other behavior)
        }
    };


    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };


    return (
        <div>
            <Header1 userId={userId} onLogout={onLogout} />

            <Typography
                variant="h3"
                component="h1"
                align="center"
                fontSize={{ xs: '2rem', sm: '2.5rem', md: '3rem' }}
                sx={{
                    backgroundImage: 'linear-gradient(45deg, #00bfff, #ff00ff)',
                    mt: 2,
                    letterSpacing: 7,
                    WebkitBackgroundClip: 'text',  // This makes the gradient clip to the text
                    color: 'transparent',  // Makes the text itself transparent to show the gradient
                    // fontWeight: 'bold',  // Optional: you can make the text bold
                }}
                gutterBottom
            >
                Session Booking
            </Typography>
            <Box sx={{ backgroundColor: "#000000", minHeight: "100vh", marginTop: "50px", marginBottom: "100px" }}>
                <Grid container spacing={3} sx={{ height: "100%", backgroundColor: '#000000', justifyContent: 'center' }}>



                    <Grid container justifyContent="center">
                        <Box sx={{
                            padding: { xs: "2rem", sm: "3rem" }, // Responsive padding
                            backgroundColor: "#2222", // Darker background for modern look
                            color: "#fff",
                            borderRadius: "16px",
                            height: "100%",
                            boxSizing: "border-box",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            "&:hover": {
                                transform: "translateY(-5px)",
                                boxShadow: "0 8px 20px rgba(0, 0, 0, 0.3)",
                            },
                        }}>

                            {/* Container for section and subsection names */}
                            <Box sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "100%",
                                mb: 2,
                            }}>

                            </Box>




                            <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: "1rem" }}>
                                <Avatar sx={{
                                    width: 150,
                                    height: 150,
                                    // mr: 2,
                                }} src={`${API_URL}${profile_picture}` || '/default-avatar.png'} alt={name || 'User'} />






                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    // Margin top for some space between the image and the icons
                                }}>

                                </Box>

                                <Tooltip title="Click to view" placement="bottom">
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontWeight: "bold",
                                            color: "#fff",
                                            mb: 2,
                                            letterSpacing: 7,
                                            fontFamily: "'Helvetica', sans-serif",
                                            "&:hover": { color: '#1E90FF' },
                                            fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' },  // Responsive font size
                                        }}
                                    >
                                        {name || "name"} {surname || "surname"}
                                    </Typography>
                                </Tooltip>


                            </Box>


                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 500,
                                    marginBottom: "1.5rem",
                                    color: "#fff",
                                    letterSpacing: 1,
                                    textAlign: "center",
                                    fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                                    fontSize: {
                                        xs: '1rem',   // small phones
                                        sm: '1.2rem', // tablets
                                        md: '1.4rem', // small desktops
                                        lg: '1.55rem' // large desktops
                                    },
                                    lineHeight: 1.6,
                                    "&:hover": {
                                        color: '#1E90FF',
                                    },
                                }}
                            >
                                "{topic_name}"
                            </Typography>











                            {/* Grid of details */}
                            <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 5 }}>

                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: "bold",
                                        color: "#fff",
                                        background: "linear-gradient(45deg, #333333, #555555)",

                                        borderRadius: "8px",
                                        padding: "6px 12px",
                                        mr: 1,
                                        mt: 1,
                                        letterSpacing: 7,
                                        textTransform: "uppercase",
                                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
                                        display: "inline-block",
                                        fontSize: "0.875rem", // Smaller size for compactness
                                        letterSpacing: "0.8px",
                                        transition: "transform 0.3s ease-in-out, background 0.3s ease-in-out",
                                        "&:hover": {
                                            background: "linear-gradient(45deg, #6e7dff, #6b89ff)",
                                            transform: "scale(1.05)",
                                        },
                                        "@media (max-width: 600px)": {
                                            fontSize: "0.75rem", // Make text smaller on mobile
                                            padding: "4px 10px", // Adjust padding for smaller screens
                                        },
                                    }}
                                >
                                    Language: {language || "N/A"}
                                </Typography>


                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: "bold",
                                        color: "#fff",

                                        background: "linear-gradient(45deg, #333333, #555555)",
                                        borderRadius: "8px",
                                        padding: "6px 12px",
                                        textTransform: "uppercase",
                                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
                                        display: "inline-block",
                                        mr: 1,
                                        mt: 1,
                                        letterSpacing: 7,
                                        fontSize: "0.875rem", // Smaller size for compactness
                                        letterSpacing: "0.8px",
                                        transition: "transform 0.3s ease-in-out, background 0.3s ease-in-out",
                                        "&:hover": {
                                            background: "linear-gradient(45deg, #6e7dff, #6b89ff)",
                                            transform: "scale(1.05)",
                                        },
                                        "@media (max-width: 600px)": {
                                            fontSize: "0.75rem", // Make text smaller on mobile
                                            padding: "4px 10px", // Adjust padding for smaller screens
                                        },
                                    }}
                                >
                                    Price: {`\u20B9`}{price}
                                </Typography>


                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: "bold",
                                        color: "#fff",
                                        background: "linear-gradient(45deg, #333333, #555555)",

                                        borderRadius: "8px",
                                        padding: "6px 12px",
                                        textTransform: "uppercase",
                                        mr: 1,
                                        mt: 1,
                                        letterSpacing: 7,
                                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
                                        display: "inline-block",
                                        fontSize: "0.875rem", // Smaller size for compactness
                                        letterSpacing: "0.8px",
                                        transition: "transform 0.3s ease-in-out, background 0.3s ease-in-out",
                                        "&:hover": {
                                            background: "linear-gradient(45deg, #6e7dff, #6b89ff)",
                                            transform: "scale(1.05)",
                                        },
                                        "@media (max-width: 600px)": {
                                            fontSize: "0.75rem", // Make text smaller on mobile
                                            padding: "4px 10px", // Adjust padding for smaller screens
                                        },
                                    }}
                                >
                                    Date: {date ? new Date(date).toLocaleDateString('en-GB') : 'N/A'}

                                </Typography>


                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: "bold",
                                        color: "#fff",
                                        background: "linear-gradient(45deg, #333333, #555555)",

                                        borderRadius: "8px",
                                        padding: "6px 12px",
                                        textTransform: "uppercase",
                                        mr: 1,
                                        mt: 1,
                                        letterSpacing: 7,
                                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
                                        display: "inline-block",
                                        fontSize: "0.875rem", // Smaller size for compactness
                                        letterSpacing: "0.8px",
                                        transition: "transform 0.3s ease-in-out, background 0.3s ease-in-out",
                                        "&:hover": {
                                            background: "linear-gradient(45deg, #6e7dff, #6b89ff)",
                                            transform: "scale(1.05)",
                                        },
                                        "@media (max-width: 600px)": {
                                            fontSize: "0.75rem", // Make text smaller on mobile
                                            padding: "4px 10px", // Adjust padding for smaller screens
                                        },
                                    }}
                                >
                                    Start Time: {formattedStartTime || "N/A"}
                                </Typography>


                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: "bold",
                                        color: "#fff",
                                        background: "linear-gradient(45deg, #333333, #555555)",

                                        borderRadius: "8px",
                                        padding: "6px 12px",
                                        textTransform: "uppercase",
                                        mr: 1,
                                        mt: 1,
                                        letterSpacing: 7,
                                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
                                        display: "inline-block",
                                        fontSize: "0.875rem", // Smaller size for compactness
                                        letterSpacing: "0.8px",
                                        transition: "transform 0.3s ease-in-out, background 0.3s ease-in-out",
                                        "&:hover": {
                                            background: "linear-gradient(45deg,  #6e7dff, #6b89ff)",
                                            transform: "scale(1.05)",
                                        },
                                        "@media (max-width: 600px)": {
                                            fontSize: "0.75rem", // Make text smaller on mobile
                                            padding: "4px 10px", // Adjust padding for smaller screens
                                        },
                                    }}
                                >
                                    Duration: {durationFormatted}
                                </Typography>



                            </Grid>

                            <Box
                                display="flex"
                                flexDirection="column"
                                justifyContent="center"
                                alignItems="center"
                                sx={{
                                    padding: { xs: '16px', sm: '24px', md: '32px' }, // responsive padding
                                    textAlign: 'center',
                                    width: '100%', // ensures box takes full width
                                }}
                            >
                                {getLogo(meeting_platform) ? (
                                    <img
                                        src={getLogo(meeting_platform)}
                                        alt={meeting_platform}
                                        style={{
                                            width: '80px', // default width for small screens
                                            height: 'auto', // preserve aspect ratio
                                            maxWidth: '100px', // maximum width for larger screens
                                        }}
                                    />
                                ) : (
                                    <span style={{ fontStyle: 'italic', color: 'gray', letterSpacing: 4 }}>
                                        Meeting Platform Info Not available
                                    </span>
                                )}

                                <Typography
                                    variant="body1"
                                    sx={{
                                        marginTop: '12px',
                                        fontSize: { xs: '14px', sm: '16px', md: '18px' }, // responsive font size
                                        fontWeight: 500,
                                        color: '#333',
                                        letterSpacing: 5,
                                    }}
                                >
                                    {getPlatformName(meeting_platform)} {/* Call getPlatformName() properly */}
                                </Typography>
                            </Box>

                            {(paymentStatus === 'success' || bookingCreated) ? (

                                <Box
                                    sx={{
                                        mt: 4,
                                        p: { xs: 2, sm: 3 },
                                        textAlign: 'center',
                                        borderRadius: 2,
                                        backgroundColor: '#1a1a1a', // dark card background
                                        boxShadow: 4,
                                        maxWidth: 600,
                                        margin: 'auto',
                                        border: '1px solid #2e7d32', // optional green border for emphasis
                                    }}
                                >
                                    <CheckCircleOutline
                                        sx={{
                                            fontSize: { xs: 40, sm: 50 },
                                            color: '#4caf50', // Material green
                                            mb: 1,
                                        }}
                                    />

                                    <Typography
                                        variant="h5"
                                        sx={{
                                            color: '#4caf50',
                                            fontWeight: 700,
                                            letterSpacing: 4,
                                            fontSize: {
                                                xs: '1.25rem',
                                                sm: '1.5rem',
                                                md: '1.75rem',
                                            },
                                            mb: 1,
                                        }}
                                    >
                                        Booking Confirmed!
                                    </Typography>

                                    {price > 0 && (
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                color: '#cccccc', // soft light gray for dark background
                                                letterSpacing: 2,
                                                fontSize: {
                                                    xs: '0.95rem',
                                                    sm: '1rem',
                                                },
                                                lineHeight: 1.6,
                                            }}
                                        >
                                            Thank you for your payment. We've successfully received your booking.
                                        </Typography>
                                    )}


                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: '#aaaaaa',
                                            fontSize: {
                                                xs: '0.85rem',
                                                sm: '0.95rem',
                                            },
                                            letterSpacing: 2,
                                        }}
                                    >
                                        You can view your booking in{' '}
                                        <MuiLink
                                            component={Link}
                                            to={`/my-booking-tab-details/${id}/${userId}`}
                                            underline="hover"
                                            sx={{ color: '#ffffff', fontWeight: 'bold' }} // Customize as needed
                                        >
                                            My Bookings
                                        </MuiLink>.
                                    </Typography>
                                </Box>
                            ) : paymentStatus === 'cancelled' ? (
                                <>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexDirection: 'column',
                                            mt: 4,
                                            px: 3,
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 2,
                                                background: 'rgba(231, 76, 60, 0.1)',
                                                borderRadius: '10px',
                                                padding: '1rem 1.75rem',
                                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                                                transition: 'all 0.3s ease',
                                                '&:hover': {
                                                    transform: 'scale(1.03)',
                                                    boxShadow: '0 8px 18px rgba(0, 0, 0, 0.25)',
                                                },
                                            }}
                                        >
                                            <ErrorOutline
                                                sx={{
                                                    fontSize: { xs: 32, sm: 40 },
                                                    color: '#e74c3c',
                                                }}
                                            />

                                            <Typography
                                                variant="h6"
                                                sx={{
                                                    color: '#e74c3c',
                                                    fontWeight: 600,
                                                    letterSpacing: 2,
                                                    fontSize: {
                                                        xs: '1rem',
                                                        sm: '1.2rem',
                                                        md: '1.4rem',
                                                    },
                                                    textAlign: 'center',
                                                    lineHeight: 1.6,
                                                }}
                                            >
                                                Payment was cancelled. Please try again.
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Button
                                        component={Link}
                                        to={`/payments/post/${id}`}
                                        variant="contained"
                                        fullWidth
                                        sx={{
                                            marginTop: "2rem",
                                            backgroundColor: "#2980b9",
                                            color: "#fff",
                                            letterSpacing: 7,
                                            textTransform: "none",
                                            padding: "1rem",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Retry Payment
                                    </Button>
                                </>
                            ) : (
                                <>
                                    <Button
                                        component={Link}
                                        to={price > 0 ? `/payments/post/${id}` : '#'} // Conditionally navigate
                                        variant="contained"
                                        fullWidth
                                        sx={{
                                            marginTop: "2rem",
                                            background: "linear-gradient(45deg, #1e90ff, #1c70ff)",
                                            color: "#fff",
                                            textTransform: "none",
                                            letterSpacing: 7,
                                            padding: "1rem 2rem", // Add horizontal padding for better appearance
                                            fontWeight: "bold",
                                            fontSize: {
                                                xs: "1rem", // Smaller size for mobile
                                                sm: "1.1rem", // Medium size for tablets and small screens
                                                md: "1.2rem", // Larger size for desktops
                                            },
                                            borderRadius: "50px", // Rounded, pill-shaped button for a modern look
                                            boxShadow: "0 12px 18px rgba(0, 0, 0, 0.1)", // Subtle shadow for depth
                                            textAlign: "center",
                                            transition: "background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease", // Smooth transitions for hover effects
                                            "&:hover": {
                                                background: "linear-gradient(45deg, #1e90ff, #1c70ff)", // Slightly darker gradient on hover
                                                transform: "scale(1.05)", // Slight zoom effect on hover for interactivity
                                                boxShadow: "0 18px 30px rgba(0, 0, 0, 0.2)", // Stronger shadow on hover for more depth
                                            },
                                            "@media (max-width: 600px)": {
                                                padding: "0.8rem 1.5rem", // Adjust padding for small screens
                                            },
                                        }}
                                        onClick={() => {
                                            if (price <= 0) {
                                                setOpenConfirmDialog(true);
                                            }
                                        }}
                                    >
                                        Book Now
                                    </Button>



                                </>
                            )}

                            <Grid container spacing={2} sx={{
                                justifyContent: "center", marginTop: "5px", backgroundColor: '#1111', borderColor: '#5555',
                                borderRadius: "15px",
                                "&:hover": {
                                    borderColor: '#1E90FF',
                                },
                            }}>



                                <Grid item xs={2} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <Link component="button" onClick={() => handleReportClick(id)} sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Box display="flex" flexDirection="column" alignItems="center">
                                            <Tooltip title="Report" placement="left">
                                                <FlagIcon
                                                    sx={{
                                                        fontSize: { xs: "3rem", sm: "3rem", md: "3rem" }, // Responsive icon size for different screens
                                                        color: "white",
                                                        transition: "all 0.3s ease", // Smooth transitions for hover effects
                                                        cursor: "pointer", // Pointer cursor to indicate interactivity
                                                        "&:hover": {
                                                            color: "#e74c3c", // Change color on hover (using a red shade for attention)
                                                            transform: "scale(1.1)", // Slight zoom effect for interactivity
                                                        },
                                                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)", // Add subtle shadow for depth
                                                        borderRadius: "8px", // Smooth rounded corners for a modern look
                                                        padding: "8px", // Padding to give space around the icon
                                                        display: "inline-block", // Ensure it behaves like an inline element
                                                    }}
                                                /></Tooltip>

                                        </Box>


                                    </Link>
                                </Grid>



                            </Grid>

                            <Box sx={{ textAlign: 'center', marginTop: '1rem', padding: '1rem', width: '100%' }}>


                            </Box>
                        </Box>

                    </Grid>

                    <Dialog
                        open={openConfirmDialog}
                        onClose={() => setOpenConfirmDialog(false)}
                        PaperProps={{
                            sx: {
                                borderRadius: "16px",
                                padding: 2,
                                backgroundColor: "#000000", // Dark background
                                boxShadow: "0 20px 40px rgba(0, 0, 0, 0.6)",
                                maxWidth: 420,
                                mx: 'auto',
                            },
                        }}
                        transitionDuration={300}
                    >
                        <DialogTitle
                            sx={{
                                fontWeight: 'bold',
                                fontSize: '1.5rem',
                                textAlign: 'center',
                                color: '#1E90FF', // Accent color
                                pb: 1,
                            }}
                        >
                            Confirm Booking
                        </DialogTitle>

                        <DialogContent sx={{ textAlign: 'center', px: 3 }}>
                            <Typography sx={{ fontSize: '1rem', color: '#ccc' }}>
                                Are you sure you want to book this session?
                            </Typography>
                        </DialogContent>

                        <DialogActions sx={{ justifyContent: 'center', gap: 2, mt: 2 }}>
                            <Button
                                onClick={() => setOpenConfirmDialog(false)}
                                sx={{
                                    borderRadius: '25px',
                                    padding: '0.6rem 1.5rem',
                                    backgroundColor: '#333',
                                    color: '#ddd',
                                    textTransform: 'none',
                                    "&:hover": {
                                        backgroundColor: '#444',
                                    },
                                }}
                            >
                                Cancel
                            </Button>

                            <Button
                                onClick={() => {
                                    createUserPostBookings();
                                    setOpenConfirmDialog(false);
                                }}
                                variant="contained"
                                sx={{
                                    borderRadius: '25px',
                                    padding: '0.6rem 1.8rem',
                                    textTransform: 'none',
                                    background: "linear-gradient(45deg, #1e90ff, #1c70ff)",
                                    fontWeight: 'bold',
                                    letterSpacing: 1,
                                    color: '#fff',
                                    "&:hover": {
                                        transform: 'scale(1.05)',
                                        boxShadow: '0 8px 20px rgba(30, 144, 255, 0.4)',
                                    },
                                }}
                            >
                                Confirm
                            </Button>
                        </DialogActions>
                    </Dialog>








                </Grid>

            </Box>

            <UserFeedbacks userId={user_id} />
            <IconButton
                onClick={scrollToTop}
                sx={{ position: 'fixed', bottom: 16, right: 16, backgroundColor: 'white', color: 'black' }}>
                <ArrowUpwardIcon />
            </IconButton>
            <Footer2 />
        </div>
    );
};

export default PostTabDetails;